export default __webpack_public_path__ + "static/media/bookmark.491ecd1e.svg";